<template>
  
  <router-view/>
</template>

<style>
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family:"Fire sans",sans-serif;
  }
  body{
    background-color: #030e1b;
    color: #fff;
  }
  a{
    color: #2aeb74;
    text-decoration: none;
  }
  button{
    background:none;
    cursor: pointer;
    appearance: none;
    border: none;

    color: #030e1b;
    padding: 0.5rem 1rem;
    background-color: #2aeb74;
    font-size: 1.125rem;
    border-radius: 0.5rem;
  }
</style>
